import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

const RegisterPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    EmpId: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    const errs = {};

    if (!form.name || form.name.length < 3) errs.name = "Name too short";
    if (!EMAIL_REGEX.test(form.email)) errs.email = "Invalid email";
    if (!form.phone || form.phone.length < 10)
      errs.phone = "Invalid phone number";
    if (!form.password || form.password.length < 6)
      errs.password = "Password too short";

    if (!form.EmpId || form.EmpId.length < 3)
      errs.EmpId = "Unique code must be at least 3 characters";

    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    // SAVE EmpId to localStorage
    localStorage.setItem("registeredEmpId", form.EmpId);

    alert("Signup successful!");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-xl rounded-xl p-6 w-full max-w-md">
        <h2 className="text-2xl font-semibold text-center mb-4">
          Create Account
        </h2>

        <form onSubmit={handleSignup} className="space-y-4">

          <input
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />
          {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}

          <input
            name="email"
            placeholder="Email"
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />
          {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}

          <input
            name="phone"
            placeholder="Phone"
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />
          {errors.phone && <p className="text-red-600 text-sm">{errors.phone}</p>}

          <input
            name="EmpId"
            placeholder="Unique Code"
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />
          {errors.EmpId && (
            <p className="text-red-600 text-sm">{errors.EmpId}</p>
          )}

          <div className="relative">
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-3 text-gray-500"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {errors.password && (
            <p className="text-red-600 text-sm">{errors.password}</p>
          )}

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-lg mt-2"
          >
            Register
          </button>
        </form>

        <a
          href="/"
          className="block text-center text-blue-600 mt-4 hover:underline"
        >
          Back to Login
        </a>
      </div>
    </div>
  );
};

export default RegisterPage;
